export const RoleCode = {
  APPLICANT: 0,
  BROKER: 1,
};

export const LoanType = {
  SBL: 0,
  RND: 1,
};

export const StakeholderRole = {
  DIRECTOR: 0,
  SHAREHOLDER: 1,
  EXECUTANT: 2,
};

export const LoanStatusCode = {
  PENDING_WITH_APPLICANT: 0,
  SUBMITTED: 1,
  UNDER_REVIEW: 2,
  APPROVED: 3,
  REJECTED: 4,
  MORE_DOCUMENTS_REQUIRED: 5,
  LOAN_DISBURSED: 6,
  NEED_CALIRIFICATION: 7,
  CALL_BACK: 8,
  AMOUNT_REQUESTED_ABOVE_PROPERTY_VALUE: 9,
};

export const DocumentStatusCode = {
  REQUESTED: 0,
  UPLOADED: 1,
  NEEDCLARIFICATION: 2,
  ACCEPTED: 3,
};

export const PaymentStatus = {
  PENDING: 0,
  PAID: 1,
};

export const KYBStatusCode = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
};

export const StakeholderAddedByStatusCode = {
  APPLICANT: 0,
  ADMIN: 1,
};

export const KYCStatusCode = {
  LINK_NOT_SENT: 0,
  SENT: 1,
  VERIFIED: 2,
  FAILED: 3,
};

export const ESignDocumentStatus = {
  REQUESTED: 0,
  PARTIALY_SIGNED: 1,
  SIGNED: 2,
  DECLINED: 3,
};

export const ESignStakeholderStatus = {
  REQUESTED: 0,
  SIGNED: 1,
  DECLINED: 2,
};

export const LOAN_PURPOSE = [
  {
    value: "day-to-day-capital",
    label: "Day-to-day capital",
  },

  {
    value: "new-fit-out",
    label: "New-fit-out",
  },
  {
    value: "expansion",
    label: "Expansion",
  },
  {
    value: "renovation",
    label: "Renovation",
  },
  {
    value: "hiring-or-paying-staff",
    label: "Hiring or paying staff",
  },
  {
    value: "purchasing-vehicle-or-transport-for-business",
    label: "Purchasing Vehicle or Transport for business",
  },
  {
    value: "purchasing-machinery-or-equipment",
    label: "Purchasing Machinery or Equipment",
  },
  {
    value: "pay-domestic-or-international-suppliers",
    label: "Pay domestic or international suppliers",
  },
  {
    value: "waiting-for-invoices-to-be-paid",
    label: "Waiting for invoices to be paid",
  },
  {
    value: "property-development-and-construction",
    label: "Property, Development and construction",
  },
  {
    value: "start-a-new-business",
    label: "Start a new business",
  },
  {
    value: "purchase-an-existing-business",
    label: "Purchase an existing business",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const EXPECTED_TIME = [
  {
    value: "As soon as possible",
    label: "As soon as possible",
  },
  { value: "Within a week", label: "Within a week" },
  {
    value: "Within 2–3 weeks",
    label: "Within 2–3 weeks",
  },
  {
    value: "I have a specific date",
    label: "I have a specific date",
  },
  {
    value: "Just exploring options for now",
    label: "Just exploring options for now",
  },
];

export const REPAYMENT_METHOD = [
  {
    value: "Interest only (monthly in advance)",
    label: "Interest only (monthly in advance)",
  },
  {
    value: "Interest Capitalised",
    label: "Interest Capitalised",
  },
];

export const ENTITY_TYPE = [
  {
    value: "sole-trader",
    label: "Sole trader",
  },

  {
    value: "partnership",
    label: "Partnership",
  },
  {
    value: "company",
    label: "Company",
  },
  {
    value: "trust",
    label: "Trust",
  },
];

export const LOANPAYBACK_OPTION = [
  {
    value: "cash-flow",
    label: "Cash flow",
  },
  {
    value: "refinance",
    label: "Refinance",
  },
  {
    value: "sale-of-an-asset",
    label: "Sale of an asset",
  },
  {
    value: "sale-of-stock",
    label: "Sale of stock",
  },
  {
    value: "working-capital",
    label: "Working capital",
  },
];

export const BROKER_COMMISSION_RATE = [
  { value: 0.25, label: "0.25%" },
  { value: 0.5, label: "0.50%" },
  { value: 0.75, label: "0.75%" },
  { value: 1, label: "1.00%" },
  { value: 1.25, label: "1.25%" },
  { value: 1.5, label: "1.50%" },
  { value: 1.75, label: "1.75%" },
  { value: 2.0, label: "2.00%" },
  { value: 2.25, label: "2.25%" },
  { value: 2.5, label: "2.50%" },
  { value: 2.75, label: "2.75%" },
  { value: 3.0, label: "3.00%" },
];

export const PROPERTY_TYPE = [
  {
    value: "Residential",
    label: "Residential",
  },
  {
    value: "Commercial",
    label: "Commercial",
  },
  {
    value: "Vacant Land",
    label: "Vacant Land",
  },
  {
    value: "Mixed use",
    label: "Mixed-use",
  },
];

export const MORGAGE_OPTIONS = [
  {
    value: "I want to refinance",
    label: "I want to refinance",
  },
  {
    value: "I will payout",
    label: "I will payout",
  },
  {
    value: "I’ll decide later",
    label: "I’ll decide later",
  },
];

export const GENERAL_DATA = [
  {
    title: "What makes EZIFIN different from other lenders?",
    content:
      "EZIFIN brings together property-backed business solutions, R&D finance on a single platform. We focus on flexibility, speed, and transparency, with an adviser-first approach that reduces paperwork and streamlines execution.",
  },
  {
    title: "Who is EZIFIN designed for — advisers, businesses or investors?",
    content:
      "All three. Businesses access tailored capital solutions, advisers gain a simplified platform to manage clients’ needs, and investors benefit from clear and transparent secured business loan opportunities.",
  },
  {
    title: "What types of funding products does EZIFIN offer?",
    content:
      "We offer secured business loans facilities, R&D finance advances and hybrid solutions that combine multiple funding types to match unique client needs.",
  },
  {
    title: "How quickly can EZIFIN provide funding compared to banks?",
    content:
      "Our processes are built for speed. While traditional lenders can take weeks or months, EZIFIN can provide conditional approval within hours and settlement shortly after all documentation is complete.",
  },
  {
    title: "Does EZIFIN only operate in Australia?",
    content:
      "EZIFIN is based in Australia and focused on serving Australian businesses, advisers and investors.",
  },
];

export const SECURED_BUSINESS_LOAN = [
  {
    title: "What are secured business loans?",
    content:
      "Secured business loans are non-bank lending solutions that provides capital secured against assets such as property, with flexible terms to suit the borrower.",
  },
  {
    title: "How does EZIFIN structure secured business loans facilities?",
    content:
      "Each facility is bespoke — tailored to cashflow, business objectives, available security and term rather than forcing clients into a standard product.",
  },
  {
    title: "What types of security does EZIFIN accept?",
    content:
      "We can structure facilities against first or second mortgaged properties, all depending on the borrower’s profile.",
  },
  {
    title: "What terms are available for secured business loans loans?",
    content:
      "Terms vary, but typically range from short-term lending to 12 month terms aligned to the borrower’s request. Interest capitalised or monthly repayment options.",
  },
  {
    title: "Can secured business loans be combined with other funding types?",
    content:
      "Yes. We often blend secured business loans with R&D finance or working capital solutions, reducing the need for multiple lenders.",
  },
];

export const RND = [
  {
    title: "What is R&D finance?",
    content:
      "R&D finance allows businesses to access funds in advance of receiving their R&D tax incentive refund, turning a future entitlement into immediate working capital.",
  },
  {
    title: "How does EZIFIN’s R&D finance process work?",
    content:
      "We assess your R&D claim, structure an advance against the expected refund, and provide funding that can be used to support payroll, growth, or ongoing innovation.",
  },
  {
    title: "Who is eligible for R&D finance?",
    content:
      "Businesses registered for the R&D tax incentive program and expecting a refund are generally eligible, subject to our due diligence.",
  },
  {
    title: "How much of my expected refund can I access?",
    content:
      "Funding is tailored to your business, but you can typically access up to 80% of your expected refund upfront.",
  },
  {
    title: "Can R&D finance be renewed each year?",
    content:
      "Yes. Many clients use R&D advances annually to support cashflow and reinvest into ongoing innovation.",
  },
  {
    title: "What information is required to apply?",
    content:
      "Personal Information, Business Purpose, details of your security (if applicable), and R&D claim documentation if applying for an advance.",
  },
  {
    title: "How does EZIFIN simplify things for advisers?",
    content:
      "We consolidate multiple funding needs — secured business loans and property-backed facilities, or R&D Funding — We are real people with a real understanding.",
  },
  {
    title: "Are fees and costs transparent?",
    content:
      "Yes. All establishment costs, interest rates, and any ongoing fees are disclosed upfront, with no hidden surprises. We can also include the end facility limit so you can be clear on the total exposure you will be liable for validating the rate being charged.",
  },
  {
    title: "Can facilities be repaid early?",
    content:
      "Most EZIFIN facilities allow for early repayment without heavy penalties, depending on the structure agreed.",
  },
  {
    title: "How does EZIFIN manage risk for borrowers and investors?",
    content:
      "We apply rigorous due diligence, require appropriate security, and monitor facilities to protect both clients and investors, ensuring responsible lending and sustainable outcomes.",
  },
];

export const KYCStatusText: Record<number, string> = {
  [KYCStatusCode.LINK_NOT_SENT]: "Link Not Sent",
  [KYCStatusCode.SENT]: "ID verification pending",
  [KYCStatusCode.VERIFIED]: "ID verification completed",
  [KYCStatusCode.FAILED]: "ID verification rejected",
};

export const KYCStatusColor: Record<number, string> = {
  [KYCStatusCode.LINK_NOT_SENT]: "",
  [KYCStatusCode.SENT]: "#2049AD",
  [KYCStatusCode.VERIFIED]: "#7DDB25",
  [KYCStatusCode.FAILED]: "#D32F2F",
};

export const KYCStatusLabel: Record<number, string> = {
  [KYCStatusCode.LINK_NOT_SENT]: "Link not sent",
  [KYCStatusCode.SENT]: "Pending verification",
  [KYCStatusCode.VERIFIED]: "Completed",
  [KYCStatusCode.FAILED]: "Failed verification",
};

export const TAX_YEAR = [
  {
    value: 2022,
    label: "2022",
  },
  { value: 2023, label: "2023" },
  {
    value: 2024,
    label: "2024",
  },
  {
    value: 2025,
    label: "2025",
  },
  {
    value: 2026,
    label: "2026",
  },
];

export const columnsListLoans = [
  { field: "loanNumber", headerName: "Loan Number" },
  { field: "loanType", headerName: "Loan Type" },
  { field: "loanStatus", headerName: "Application Status" },
  { field: "loanApplicationSubmittedDate", headerName: "Submitted Date" },
];

export const columnsListBroker = [
  { field: "loanNumber", headerName: "Loan Number" },
  { field: "email", headerName: "Email" },
  { field: "loanType", headerName: "Loan Type" },
  { field: "loanStatus", headerName: "Application Status" },
  { field: "loanApplicationSubmittedDate", headerName: "Submitted Date" },
];
